// A small stack so nested overlays (the photo lightbox and the attachment/PDF viewer)
// close on the browser Back button — and on Android's system back — instead of closing
// the card behind them.
//
// Opening an overlay registers a close handler and pushes one history entry. The app's
// single popstate handler runs the topmost handler first (see runOverlayBack). Every
// in-app close trigger (Close button, backdrop tap, Escape) goes through
// requestOverlayClose(), which steps history back so the same path runs and the pushed
// entry is consumed — no dangling history entries.

type BackHandler = () => void;
const stack: BackHandler[] = [];

export function registerOverlayBack(handler: BackHandler): () => void {
  stack.push(handler);
  window.history.pushState({ safeWalletOverlay: true }, '');
  return () => {
    const index = stack.lastIndexOf(handler);
    if (index >= 0) stack.splice(index, 1);
  };
}

// Call from the app's popstate handler, before its own layer handling.
// Returns true if it closed an overlay (so the caller should stop).
export function runOverlayBack(): boolean {
  const handler = stack.pop();
  if (!handler) return false;
  handler();
  return true;
}

// Programmatic close: step history back so runOverlayBack runs the handler and the
// pushed entry is consumed. No-op if nothing is open.
export function requestOverlayClose(): void {
  if (stack.length > 0) window.history.back();
}
